<div class="ai-content-generator-modal">
  <!-- Modal Header with AI Copilot Badge & Title -->
  <div class="ai-modal-header border-bottom">
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center gap-3">
        <div class="ai-sparkle-badge">
          <i class="fas fa-magic"></i>
        </div>
        <div>
          <h3 class="ai-modal-title mb-0">
            {{ "AI Content Assistant" | translate }}
          </h3>
          <p class="ai-modal-subtitle mb-0">
            {{ "Generate optimized copy and metadata powered by AI" | translate }}
          </p>
        </div>
      </div>
      <button
        type="button"
        class="ai-close-btn"
        aria-label="Close"
        (click)="closeModal()"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>

  <div class="modal-body p-4">
    <div *ngIf="dataIsLoading; else loadedContent">
      <div class="text-center py-5">
        <mat-spinner class="mx-auto my-3" [diameter]="44"></mat-spinner>
        <p class="text-xs text-gray-500 mt-2">{{ "Loading AI template parameters..." | translate }}</p>
      </div>
    </div>
    
    <ng-template #loadedContent>
      <!-- Option Parameters Grid -->
      <div class="row g-3 mb-4">
        <div
          *ngFor="let paramField of getOptions()"
          class="col-12 col-sm-6 col-lg-4 mb-2"
        >
          <ng-container *ngIf="isOptionVisible(paramField)">
            <label class="ai-field-label">
              <span class="text-capitalize">{{ formatLabel(paramField) }}</span>

              <ng-container *ngIf="!useDropdownOption(paramField)">
                <input
                  type="text"
                  class="form-control ai-option-input mt-1"
                  [(ngModel)]="params[paramField]"
                />
              </ng-container>

              <ng-container *ngIf="useDropdownOption(paramField)">
                <div ngbDropdown class="d-inline-block w-100 mt-1">
                  <button
                    type="button"
                    class="btn btn-outline-secondary w-100 truncate ai-dropdown-toggle"
                    [id]="'dropdownBasic-' + paramField"
                    ngbDropdownToggle
                  >
                    <span>{{ getOptionLabelByValue(paramField, getOptionValue(paramField)) }}</span>
                    <i class="fi fi-rr-angle-small-down ml-1 text-xs"></i>
                  </button>
                  <div
                    ngbDropdownMenu
                    class="custom-dropdown max-h-60 overflow-auto w-100"
                    [attr.aria-labelledby]="'dropdownBasic-' + paramField"
                  >
                    <ng-container *ngFor="let item of getOptionSelections(paramField)">
                      <button
                        ngbDropdownItem
                        (click)="setOptionValue(paramField, item.optionValue)"
                      >
                        {{ item.optionLabel }}
                      </button>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </label>
          </ng-container>
        </div>
      </div>

      <!-- Generated AI Content Output -->
      <div *ngIf="generatedContent" class="mb-4">
        <div class="ai-generated-box">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <div class="d-flex align-items-center gap-2">
              <span class="ai-generated-badge">
                <i class="fas fa-magic text-emerald-500 mr-1.5"></i>
                {{ "Generated Content" | translate }}
              </span>
            </div>
            <button
              type="button"
              class="btn btn-light btn-sm ai-regen-btn"
              [class.is-loading]="isLoading || dataIsLoading"
              (click)="generateContent()"
            >
              <i class="fas fa-sync-alt mr-1"></i> {{ "Regenerate" | translate }}
            </button>
          </div>
          
          <div class="ai-generated-text">
            {{ generatedContent }}
          </div>
        </div>
      </div>

      <!-- Main Action Bar -->
      <div class="ai-action-bar">
        <ng-container *ngIf="generatedContent; else contentGenerated">
          <div class="d-flex items-center gap-2 w-100">
            <button
              type="button"
              class="btn btn-outline-secondary w-50 ai-action-btn"
              [class.is-loading]="isLoading || dataIsLoading"
              (click)="generateContent()"
            >
              <i class="fas fa-redo mr-1.5"></i> {{ "Generate Again" | translate }}
            </button>

            <button
              type="button"
              class="btn btn-primary w-50 ai-action-btn ai-use-btn"
              [class.is-loading]="isLoading"
              (click)="useGeneratedContent()"
            >
              <i class="fas fa-check-circle mr-1.5"></i> {{ "Use This Content" | translate }}
            </button>
          </div>
        </ng-container>

        <ng-template #contentGenerated>
          <button
            type="button"
            class="btn btn-primary w-100 ai-action-btn ai-generate-primary"
            [class.is-loading]="isLoading || dataIsLoading"
            (click)="generateContent()"
          >
            <i class="fas fa-bolt mr-2"></i> {{ "Generate with AI" | translate }}
          </button>
        </ng-template>
      </div>

    </ng-template>
  </div>
</div>
